function initFaqAccordions() {
  const faqSections = document.querySelectorAll('[data-faq-accordion]');

  faqSections.forEach(function(section) {
    // Skip if already initialized
    if (section.dataset.initialized === 'true') {
      return;
    }
    section.dataset.initialized = 'true';

    const items = section.querySelectorAll('[data-faq-item]');

    items.forEach(function(item) {
      const button = item.querySelector('.faq-section__button');
      const content = item.querySelector('.faq-section__content');

      if (button && content) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const isActive = item.classList.contains('active');

          if (isActive) {
            item.classList.remove('active');
            button.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0';
          } else {
            item.classList.add('active');
            button.setAttribute('aria-expanded', 'true');
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        });
      }
    });
  });
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqAccordions);
} else {
  // DOM is already ready, initialize immediately
  initFaqAccordions();
}

// Re-initialize when Shopify section is loaded/reloaded in theme editor
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initFaqAccordions);
}
